<blockable-div id="moc-event-details-container" #details>
  <p-blockUI [blocked]="loading || saving" [target]="details" />
  <app-progress-spinner [enabled]="saving || loading" />
  @if (form && !loading) {
    <form [formGroup]="form" id="moc-event-details">
      <div class="top-bar">
        @if (mocEvent?.id) {
          <div class="button-wrapper no-padding-top-bottom">
            <div class="label">{{ 'COMMON.LABEL.ACTIONS' | translate }}:</div>
            <div class="no-padding-top-bottom">
              <p-select
                [options]="actions"
                [(ngModel)]="selectedAction"
                [ngModelOptions]="{ standalone: true }"
                (onChange)="actionEvent($event, dd)"
                scrollHeight="calc(100vh-35vh)"
                styleclass="action-drop-down"
                #dd
              />
            </div>
          </div>
        }
        @if (!isEditting && canCreate) {
          <div class="button-wrapper no-padding-top-bottom">
            <button
              pButton
              label="{{ 'COMMON.LABEL.BUTTONS.EDIT' | translate }}"
              icon="fa fa-fw fa-edit"
              (click)="setEditting()"
            ></button>
          </div>
        } @else if (isEditting && canCreate) {
          <div class="button-wrapper no-padding-top-bottom">
            <button
              pButton
              label="{{ 'COMMON.LABEL.BUTTONS.SAVE' | translate }}"
              icon="fa fa-fw fa-save"
              [disabled]="!isFormValid() || this.saving"
              (click)="saveMocEvent()"
            ></button>
          </div>
        }
      </div>
      <div class="panel">
        <div class="no-padding row">
          <div class="row-item">
            <div class="label">{{ 'CRM.LABEL.TITLE' | translate }}:</div>
            <div class="input">
              <input type="text" pInputText formControlName="title" />
            </div>
          </div>

          <div class="row-item">
            <div class="label">{{ 'CRM.LABEL.EVENT_TYPE' | translate }}:</div>
            <div class="input">
              <p-select
                [options]="eventTypes"
                formControlName="eventType"
                (onChange)="eventTypeChanged($event)"
                styleClass="w-100"
              />
            </div>
          </div>

          <div class="row-item">
            <div class="label">
              {{ 'CRM.LABEL.EVENT_CATEGORY' | translate }}:
            </div>
            <div class="input">
              <p-multiSelect
                [options]="eventCategories"
                formControlName="eventCategories"
              />
            </div>
          </div>
        </div>

        <div class="no-padding row">
          <div class="row-item">
            <div class="label">{{ 'CRM.LABEL.EVENT_STATUS' | translate }}:</div>
            <div class="input">
              <input type="text" pInputText formControlName="eventStatus" />
            </div>
          </div>

          <div class="row-item">
            <div class="label">
              {{ 'COMMON.LABEL.START_DATE' | translate }}:
            </div>
            <div class="input">
              <p-datepicker
                formControlName="startDt"
                [showTime]="true"
                [defaultDate]="defaultStartDate"
              />
            </div>
          </div>

          <div class="row-item">
            <div class="label">{{ 'COMMON.LABEL.END_DATE' | translate }}:</div>
            <div class="input">
              <p-datepicker
                formControlName="endDt"
                [showTime]="true"
                [defaultDate]="defaultEndDate"
              />
            </div>
          </div>
        </div>

        <div class="no-padding row">
          <div class="row-item">
            <div class="label">{{ 'CRM.LABEL.AORS' | translate }}:</div>
            <div class="input">
              <p-multiSelect [options]="districts" formControlName="aors" />
            </div>
          </div>
          <div class="row-item">
            <div class="label">
              {{ 'COMMON.LABEL.CREATED_BY' | translate }}:
            </div>
            <div class="input">
              <input type="text" pInputText formControlName="createdBy" />
            </div>
          </div>

          <div class="row-item">
            <div class="label">
              {{ 'COMMON.LABEL.CREATED_AT' | translate }}:
            </div>
            <div class="input">
              <p-datepicker
                formControlName="createdAt"
                [showTime]="true"
                [hourFormat]="'12'"
              />
            </div>
          </div>
        </div>

        <div class="no-padding row">
          <div class="row-item-long">
            <div class="label">
              {{ 'CRM.LABEL.SAP_OUTAGE_NUMBER' | translate }}:
            </div>
            <div class="input">
              <input type="text" pInputText formControlName="sapOutageNumber" />
            </div>
          </div>
        </div>

        <div class="no-padding row">
          <div class="row-item-long">
            <div class="label">{{ 'CRM.LABEL.DESCRIPTION' | translate }}:</div>
            <div class="input">
              <textarea
                pTextarea
                formControlName="description"
                [rows]="5"
              ></textarea>
            </div>
          </div>
        </div>

        <div class="no-padding row">
          <div class="row-item-long">
            <div class="label">{{ 'CRM.LABEL.DOCUMENT' | translate }}:</div>
            <div class="input">
              <input type="text" pInputText formControlName="document" />
            </div>
            <div>
              <img
                src="assets/images/link.png"
                onmouseover="this.src = 'assets/images/link_hover.png'"
                onmouseout="this.src = 'assets/images/link.png'"
                style="width: 30px; height: 30px"
                (click)="OpenLink()"
              />
            </div>
          </div>
        </div>
      </div>
      <div>
        <p-panel
          [toggleable]="true"
          header="{{ 'CRM.LABEL.MOC_NOTES' | translate }}"
        >
          <body class="notes-panel-content">
            <div>
              @if (mocEvent?.id && canCreate) {
                <div class="add-entry-button">
                  <button
                    pButton
                    label="{{ 'COMMON.LABEL.BUTTONS.ADD' | translate }}"
                    icon="fa fa-fw fa-plus"
                    (click)="showEntryForm()"
                  ></button>
                </div>
              }
              @if (eventEntries) {
                @for (entry of eventEntries; track entry.id) {
                  <app-log-entry
                    [entry]="entry"
                    [canEdit]="true"
                    [canDelete]="true"
                    (editEvent)="editEntry($event)"
                    (deleteEvent)="deleteEntry($event)"
                  />
                }
              }
            </div>
          </body>
        </p-panel>
      </div>
      <div>
        <app-general-grid
          [values]="acknowledgements"
          [columns]="ackColumns"
          [rows]="50"
          [filterable]="true"
          [screenName]="screenName"
          [lazy]="false"
          [includeExportCSV]="false"
          scrollHeight="calc(50vh - 140px)"
          [usePaginator]="false"
          [rowsPerPageOptions]="[10, 20, 50]"
          [alwaysShowPaginator]="false"
          [header]="gridHeader"
          #grid
        />
      </div>
    </form>
  }

  <!-- History ID Dialog -->
  <p-dialog
    [header]="historyHeader"
    [(visible)]="viewHistory"
    showEffect="fade"
    [modal]="true"
    [transitionOptions]="'0ms'"
    (onHide)="closeHistory()"
    [style]="{ width: '500px' }"
    id="history-dialog"
  >
    @if (!isListEmpty()) {
      <div class="no-padding dialog-body">
        <div class="input">
          <div class="label">{{ 'CRM.LABEL.VERSION' | translate }}:</div>
          <div class="dropdown">
            <p-select
              [options]="mocEventVersions"
              appendTo="body"
              (onChange)="versionSelected($event)"
              styleclass="action-drop-down"
            />
          </div>
        </div>
        <div class="button">
          <button
            pButton
            label="{{ 'COMMON.LABEL.BUTTONS.OPEN' | translate }}"
            (click)="viewVersion()"
          ></button>
        </div>
      </div>
    } @else {
      <div [innerHTML]="'COMMON.LABEL.NO_AUDIT_INFO_MSG' | translate"></div>
    }
  </p-dialog>

  <!-- Notes Entry Form -->
  <p-dialog
    header="{{ 'CRM.LABEL.BUTTONS.ADD_ENTRY' | translate }}"
    [(visible)]="showEntryDialog"
    showEffect="fade"
    [modal]="true"
    [transitionOptions]="'0ms'"
    [style]="{ width: '1000px' }"
  >
    <form [formGroup]="addEntryForm!">
      <div id="moc-event-add-entry">
        <div>
          <div class="no-padding-top-bottom">
            @if (showEntryDialog) {
              <p-editor formControlName="entry" [style]="{ height: '320px' }" />
            }
          </div>

          <div class="no-padding-top-bottom label">
            {{ 'MONLOG.LABEL.ENTRY_LABEL' | translate }}
          </div>

          <div id="buttons">
            <div class="offset-6">
              <button
                pButton
                label="{{ 'COMMON.LABEL.BUTTONS.OK' | translate }}"
                icon="fa fa-fw fa-check"
                id="ok"
                (click)="addMocEntry()"
              ></button>
            </div>
            <div>
              <button
                pButton
                label="{{ 'COMMON.LABEL.BUTTONS.CANCEL' | translate }}"
                icon="fa fa-fw fa-ban"
                (click)="cancelEntryForm()"
                [disabled]="!this.addEntryForm!.valid"
              ></button>
            </div>
          </div>
        </div>
      </div>
    </form>
  </p-dialog>
</blockable-div>
